module.exports = __webpack_public_path__ + "img/cross-icon.0fc5ca85.svg";